import React from "react";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";
import { htmlToText } from "html-to-text";  // Correct import

const ExportDocx = ({ text }) => {
    const generateDocx = async () => {
        // Convert HTML to plain text while preserving basic formatting
        const parsedText = htmlToText(text, { wordwrap: false });

        // Split text into lines and process each line for DOCX
        const paragraphs = parsedText.split("\n").map(line =>
            new Paragraph({
                children: [new TextRun({ text: line, break: 1 })],
            })
        );

        const doc = new Document({
            sections: [{ properties: {}, children: paragraphs }],
        });

        const blob = await Packer.toBlob(doc);
        saveAs(blob, "document.docx");
    };

    return (
        <Button onClick={generateDocx} style={{ height: "40px" }} disabled={!text}>
            Download
        </Button>
    );
};

export default ExportDocx;
